export const ANSWER_QUESTION_START = 'ANSWER_QUESTION_START';
export const ANSWER_QUESTION_SUCCESS = 'ANSWER_QUESTION_SUCCESS';
export const ANSWER_QUESTION_FAIL = 'ANSWER_QUESTION_FAIL';
export const ANSWER_QUESTION_RESET = 'ANSWER_QUESTION_RESET';
